import axiosClient from '../interceptors';
import { ApiRoutes } from '../routes/ApiRoutes';
import { getAPIUrl } from './BaseService';
import { GradeBoundary, GradeSchemeEntity, GradeSchemeTemplate } from '../types';

export async function getGradeSchemes(): Promise<{ data: GradeSchemeEntity[] }> {
    const url = getAPIUrl() + ApiRoutes.GRADE_SCHEMES;
    const response = await axiosClient.get<GradeSchemeEntity[]>(url);
    return { data: response.data };
}

export async function getGradeSchemeTemplates(): Promise<{ data: GradeSchemeTemplate[] }> {
    const url = getAPIUrl() + ApiRoutes.GRADE_SCHEME_TEMPLATES;
    const response = await axiosClient.get<GradeSchemeTemplate[]>(url);
    return { data: response.data };
}

export async function createGradeScheme(
    schoolId: string,
    name: string,
    scheme: GradeBoundary[],
    description?: string
): Promise<{ data: GradeSchemeEntity }> {
    const body = {
        school_id: schoolId,
        name,
        description: description || null,
        scheme,
    };
    const url = getAPIUrl() + ApiRoutes.GRADE_SCHEMES;
    const response = await axiosClient.post<GradeSchemeEntity>(url, body);
    return { data: response.data };
}

export async function updateGradeScheme(
    schemeId: string,
    data: { name?: string; scheme?: GradeBoundary[]; description?: string }
): Promise<{ data: GradeSchemeEntity }> {
    const url = getAPIUrl() + ApiRoutes.GRADE_SCHEMES + '/' + schemeId;
    const response = await axiosClient.patch<GradeSchemeEntity>(url, data);
    return { data: response.data };
}

export async function deleteGradeScheme(schemeId: string): Promise<void> {
    const url = getAPIUrl() + ApiRoutes.GRADE_SCHEMES + '/' + schemeId;
    await axiosClient.delete(url);
}
